module.exports = __webpack_public_path__ + "static/cartoes-9d83b2c7464888d4b026b756fd2ebb7b.jpg";